import { Component } from "react";

// Evita que un error (p. ej. traductor del navegador alterando el DOM) deje la pantalla en blanco.
export class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error) { console.error("UI error", error); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="error-boundary" className="min-h-screen flex flex-col items-center justify-center gap-4 p-6 text-center bg-[#0B0B10] text-white">
        <p className="text-xl font-bold"><span>Algo salió mal al mostrar la pantalla.</span></p>
        <p className="text-sm text-white/60"><span>Tu información está guardada. Toca recargar para continuar.</span></p>
        <button data-testid="error-boundary-reload" onClick={() => window.location.reload()} className="h-12 px-6 rounded-xl bg-[#E85D04] font-semibold"><span>Recargar</span></button>
      </div>
    );
  }
}
